import * as React from "react";

interface PopupStateData<T = void> {
  isOpen: boolean;
  anchor: HTMLElement | null;
  metadata: T | null;
}

export interface PopupState<T = void> extends PopupStateData<T> {
  open: (params?: { anchorEl?: HTMLElement | null; metadata?: T }) => void;
  close: () => void;
}

export function usePopupState<T = void>(): PopupState<T> {
  const [state, setState] = React.useState<PopupStateData<T>>({
    isOpen: false,
    anchor: null,
    metadata: null,
  });

  const openPopup = React.useCallback(function open(
    params?: Partial<{
      anchorEl: HTMLElement | null;
      metadata: T;
    }>,
  ) {
    setState({
      isOpen: true,
      anchor: params?.anchorEl ?? null,
      metadata: params?.metadata ?? null,
    });
  }, []);

  const closePopup = React.useCallback(function close() {
    setState({
      isOpen: false,
      anchor: null,
      metadata: null,
    });
  }, []);

  return {
    ...state,
    open: openPopup,
    close: closePopup,
  };
}
